export const home = {
  landingHeroTagline:
    "Discover remanufactured components, services, and circular solutions for a sustainable industry.",
  landingHeroWindAlt: "Wind turbines generating renewable energy",
  landingHeroBatteryAlt: "Electric vehicle battery modules for reuse",
  landingHeroRemanufacturingAlt:
    "Remanufacturing facility with circular production flow",
  landingPillarWindTitle: "Renewable energy",
  landingPillarWindDesc:
    "Wind and green-power components given a second life through certified remanufacturing.",
  landingPillarBatteryTitle: "EV batteries & storage",
  landingPillarBatteryDesc:
    "Battery packs and modules refurbished for electric mobility and stationary storage.",
  landingPillarRemanufacturingTitle: "Remanufactured products",
  landingPillarRemanufacturingDesc:
    "Industrial parts restored to specification—reducing waste and raw-material demand.",
  landingPillarCircularityTitle: "Circular traceability",
  landingPillarCircularityDesc:
    "Digital product passports and transparent lifecycle data across the supply chain.",
};
